exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".folder-btn {\r\n    position: relative;\r\n    top: 0;\r\n    right: 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/shared/uploaded-file-view/uploaded-file-view.component.css
// module id = ../../../../../src/app/layout/modules/admin/programme/shared/uploaded-file-view/uploaded-file-view.component.css
// module chunks = main